import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import Horticultural from "../../components/horticultural/Horticultural";

function HorticulturalPage({ setShow }) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Horticultural Maintenance | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title={"Horticultural Maintenance"} t={t} />
      <Horticultural />
    </>
  );
}

export default HorticulturalPage;
